export default __webpack_public_path__ + "static/HKO_Group_Photo-d581494b984599f93b35ad65a02030fb.jpg";